import SidebarContainer, {
  type NavItem,
} from '@efdigital/ll-xceed-v2/components/application/sidebar-container.gts';
import PartnershipMessagingUnreadSync from '@efdigital/ll-xceed-v2/components/coaching/messaging/partnership-messaging-unread-sync.gts';
import type { CoachingCoachModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach';
import type CoachActionRequiredService from '@efdigital/ll-xceed-v2/services/coach-action-required';
import type PartnershipMessagingService from '@efdigital/ll-xceed-v2/services/partnership-messaging';
import { navBadge } from '@efdigital/ll-xceed-v2/utils/coaching/nav-badge';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

interface CoachSignature {
  Args: {
    model: CoachingCoachModel;
    controller: unknown;
  };
}

export default class CoachTemplate extends Component<CoachSignature> {
  @service declare coachActionRequired: CoachActionRequiredService;
  @service declare partnershipMessaging: PartnershipMessagingService;

  get nav(): NavItem[] {
    void this.partnershipMessaging.unreadVersion;
    const unreadCount = this.partnershipMessaging.unreadCount;
    const actionRequiredCount = this.coachActionRequired.count;

    return [
      {
        link: {
          route: 'coaching.coach.index',
        },
        icon: 'ph:squares-four',
        label: 'Dashboard',
      },
      {
        link: {
          route: 'coaching.coach.sessions',
        },
        icon: 'ph:calendar',
        label: 'Sessions',
        badge: navBadge(actionRequiredCount),
        badgeLabel: 'need attention',
      },
      {
        link: {
          route: 'coaching.coach.coachees',
        },
        icon: 'ph:users',
        label: 'Coachees',
      },
      {
        link: {
          route: 'coaching.coach.messages',
        },
        icon: 'ph:chat-circle',
        label: 'Messages',
        badge: navBadge(unreadCount),
      },
    ];
  }

  <template>
    {{pageTitle "Coach"}}

    <PartnershipMessagingUnreadSync @role="coach" />

    <SidebarContainer
      @nav={{this.nav}}
      @helpRoute="coaching.coach.help"
      @profileRoute="coaching.coach.settings"
      @profileAvatarUrl={{@model.coach.photo}}
    >
      <:content>
        {{outlet}}
      </:content>
    </SidebarContainer>
  </template>
}
